// Feature 09: Distribution Signal Badge Component

import { Chip, Tooltip, Box } from '@mui/material';
import { TrendingUp, Edit } from '@mui/icons-material';
import { DistributionSignalBadgeProps } from '../../types/distributionSignal.types';

const DistributionSignalBadge: React.FC<DistributionSignalBadgeProps> = ({
  spikeMagnitude,
  durationDays,
  isAnnotated,
  compact = false,
}) => {
  const description = `${spikeMagnitude.toFixed(1)}x spike over ${durationDays} days${
    isAnnotated ? ' (annotated)' : ''
  }`;

  const color = spikeMagnitude > 5 ? 'error' : spikeMagnitude > 3 ? 'warning' : 'info';

  return (
    <Tooltip title={description} arrow>
      <Box display="flex" gap={1} alignItems="center">
        <Chip
          icon={<TrendingUp fontSize="small" />}
          label={compact ? `${spikeMagnitude.toFixed(1)}x` : `${spikeMagnitude.toFixed(1)}x (${durationDays}d)`}
          color={color}
          size={compact ? 'small' : 'medium'}
          variant="outlined"
        />
        {isAnnotated && (
          <Tooltip title="Spike source annotated" arrow>
            <Edit fontSize="small" color="success" />
          </Tooltip>
        )}
      </Box>
    </Tooltip>
  );
};

export default DistributionSignalBadge;
